import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { Get_Null_Country_Schools } from "../../../Misc/api/Get_Null_Country_Schools";

function CountryToSchoolTODO() {
  const { logout } = StaffuseAuth();

  const [Schools, setSchools] = useState([]);
  useEffect(() => {
    Get_Null_Country_Schools(setSchools, 10000, "All", logout);
  }, []);

  function handleGoToCountrySchoolAssigner(e) {
    e.preventDefault();
    window.open(`/Staff/AssignSchoolToCountry`, "_blank");
  }

  return (
    <>
      {Schools.length > 0 ? (
        <Container maxWidth="sm">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            Schools needing a country: {Schools.length}
          </Box>
          <br></br>
          <button onClick={(e) => handleGoToCountrySchoolAssigner(e)}>
            Go To
          </button>
          <br></br>
          <br></br>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
}

export default CountryToSchoolTODO;
